import {AutorenewIcon} from '@/constants/icon'

export const STATUS_TECHNICAL_SUPPORT = {
  NOT_ACTIVE: 1,
  IN_PROGRESS: 2,
  COMPLETE: 3,
  REJECT: 4
}

export const STATUS_TECHNICAL_SUPPORT_ARRAY = [
  {
    id: STATUS_TECHNICAL_SUPPORT.NOT_ACTIVE,
    name: 'Pending',
    checked: false,
    icon: 'time',
    color: 'yellow'
  },
  {
    id: STATUS_TECHNICAL_SUPPORT.IN_PROGRESS,
    name: 'In development',
    checked: false,
    icon: '',
    svgIcon: AutorenewIcon(),
    color: 'blue'
  },
  {
    id: STATUS_TECHNICAL_SUPPORT.COMPLETE,
    name: 'Completed',
    checked: false,
    icon: 'tick',
    color: 'green'
  },
  {
    id: STATUS_TECHNICAL_SUPPORT.REJECT,
    name: 'Rejected',
    checked: false,
    icon: 'cross-big',
    color: 'red'
  }
]



// WEBPACK FOOTER //
// ./src/constants/statusTechnicalSupport.js